import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.ALL_SITES](state) {
        return state.sites;
    },
    [GETTERS.SITE_BY_UUID](state) {
        return (uuid) => state.sites[uuid];
    },
    [GETTERS.ACTIVE_SITE_UUID](state) {
        return state.active_site_uuid;
    },
};
